export default {
    data() {
        return {
        }
    },
    props: {
        to: {
            type: Object,
            default: () => {}  // 对象内字段： name: 路由名。 query: 跳转参数。 type: 跳转类型，枚举值：'default':正常路由跳转， 'newPage': 新页面跳转,默认
        },
        target: {
            type: String,
            default: '_self'
        },
        type: {
            type: String,
            default: 'default'
        },
        size: String,
        icon: {
            type: String,
            default: ''
        },
        nativeType: {
            type: String,
            default: 'button'
        },
        loading: Boolean,
        disabled: Boolean,
        plain: Boolean,
        autofocus: Boolean,
        round: Boolean,
        circle: Boolean
    },
    components: {},
    created() {
    },
    mounted() {
    },
    activated() {
    },
    deactivated() {
    },
    destroyed() {
    },
    watch: {},
    computed: {
    },
    filters: {},
    methods: {
        // handleClick() {
        //     const type = this.routerParams.type
        //     if (!type) {
        //         this.type = 'newPage'
        //     } else {
        //         this.type = type
        //     }
        //     if (this.type === 'newPage') {
        //         const __this = this;
        //         const $router = __this.$router;
        //         const resolved = $router.resolve({
        //             name: this.routerParams.name,
        //             query: this.routerParams.query,
        //         });
        //         const href = resolved.href;
        //         console.log(href);
        //         window.open(href);
        //     } else {
        //         this.$router.push(this.routerParams)
        //     }
        // },
    }
}